import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import { mediaUrl, hideBrokenImg } from '../utils/mediaUrl'

function firstImageSrc(gallery) {
  const images = gallery?.gallary_images || []
  for (const img of images) {
    const src = mediaUrl(img?.path)
    if (src) return src
  }
  return ''
}

function ImgGallery(props) {
  const galleries = props.gallaryData || [];
  const [activeIndex, setActiveIndex] = useState(0);

  if (!galleries.length) {
    return (
      <section id="imggallery">
        <div className="container">
          <h5 className="text-center font-weight-bold mb-3 heading mt-3">गैलरी</h5>
          <p className="text-center text-muted">कोणतीही गॅलरी उपलब्ध नाही.</p>
        </div>
      </section>
    );
  }

  const activeGallery = galleries[activeIndex] || galleries[0];
  const activeImages = (activeGallery.gallary_images || [])
    .map((img) => ({ ...img, src: mediaUrl(img.path) }))
    .filter((img) => img.src);

  return (
    <section id="imggallery">
      <div className="container">
        <h5 className="text-center font-weight-bold mb-3 heading mt-3">गैलरी</h5>

        <div className="row justify-content-center mb-3">
          {galleries.map((element, index) => {
            const thumb = firstImageSrc(element);
            return (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3" key={element.gallary_id || index}>
                <button
                  type="button"
                  className={`gallery-tab-btn w-100 ${index === activeIndex ? 'active' : ''}`}
                  onClick={() => setActiveIndex(index)}
                >
                  <Card style={{ width: '100%' }}>
                    {thumb ? (
                      <Card.Img
                        variant="top"
                        src={thumb}
                        alt={element.title}
                        onError={hideBrokenImg}
                      />
                    ) : (
                      <div className="gallery-thumb-placeholder" aria-hidden="true" />
                    )}
                    <Card.Body>
                      <Card.Title>{element.title}</Card.Title>
                    </Card.Body>
                  </Card>
                </button>
              </div>
            );
          })}
        </div>

        <div className="tab-content mt-3">
          {activeImages.length ? (
            <div className="row">
              {activeImages.map((img, i) => (
                <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3" key={`${activeGallery.gallary_id}-${img.gallary_images_id || i}`}>
                  <a
                    href={img.src}
                    data-toggle="lightbox"
                    data-gallery="gallery"
                    className="d-block"
                  >
                    <img
                      src={img.src}
                      alt={activeGallery.title || 'Gallery'}
                      className="img-fluid rounded"
                      onError={hideBrokenImg}
                    />
                  </a>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-muted">या गॅलरीसाठी प्रतिमा उपलब्ध नाहीत.</p>
          )}
        </div>
      </div>
    </section>
  )
}

export default ImgGallery
